import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const loc = useLocation();
  return (
    <main className="page-narrow">
      <span className="sc sc-accent">404 · Not Found</span>
      <h1
        style={{
          fontFamily: "var(--font-display)",
          fontSize: "var(--text-2xl)",
          fontWeight: 600,
          marginTop: "var(--space-2)",
          letterSpacing: "var(--track-display)",
          color: "var(--ink)",
          lineHeight: 1.15,
        }}
      >
        That page isn&rsquo;t here.
      </h1>
      <p className="text-muted" style={{ marginTop: "var(--space-3)", lineHeight: "var(--lh-normal)" }}>
        We looked for <code style={{ fontFamily: "var(--font-mono)" }}>{loc.pathname}</code> and
        came up empty. The link may have been mistyped, or the page may have moved.
      </p>
      <div className="form-actions">
        <Link to="/" className="btn btn-primary">Return home</Link>
        <button type="button" className="btn btn-ghost" onClick={() => history.back()}>
          Go back
        </button>
      </div>
      <p className="disclaim-line">
        <strong>CRE Property KB</strong> &middot; a division of Edge Realty Advisors.
      </p>
    </main>
  );
}
